import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $rewardsBalanceStore } from '@lib/store';
import { Balance, Website } from './widgets';
import { PageContainer, View } from '@widgets';

export const RewardsPage = () => {
  const rewardsBalanceStore = useUnit($rewardsBalanceStore.store);

  const { t } = useTranslation('rewards');

  useEffect(() => {
    $rewardsBalanceStore.events.getBalance();
    return $rewardsBalanceStore.events.clear;
  }, []);

  return (
    <PageContainer className='flex flex-col gap-6' title={t('title')} header={t('header')}>
      <View
        loading={rewardsBalanceStore.loading}
        noData={!rewardsBalanceStore.data}
        error={rewardsBalanceStore.error}
        onRefresh={() => $rewardsBalanceStore.events.getBalance()}
      >
        <Balance />
        <Website />
      </View>
    </PageContainer>
  );
};
